const stpesNames = ['Редактирование паспорта лифта', 'Проверка изменений']

const equipmentSidePageEditContentConstants = { stpesNames }

export default equipmentSidePageEditContentConstants
